import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

const GetDiscovered = () => {
  return (
    <div>
      <section className="section_section__I0u9H">
        <Container className="container_container__e7iG2 container_right__z3b1d container_top__tLiv0">
          <img
            src="data:image/jpeg;base64,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"
            alt="VRE"
            class=" blur-1"
            style={{
              position: "absolute",
              top: "0px",
              left: "50%",
              transform: "translateX(-50%)",
            }}
          ></img>
          <div className="content_content__hiCNB content_lg__0npCb content_marginAuto__3jHEC">
            <h2>Your Trusted Partner for Music Video Releases</h2>
            {/* <h3>VDNI Accelerator helps self-releasing artists do both.</h3> */}
            {/* <p className="">
              80,000 artists have already enrolled in Accelerator, and nearly
              10,000 artists increased their streams by an average of +143%
              compared to the previous quarter.
            </p> */}
            <p className="">
            Our official music video release partner is dedicated to bringing your creative vision to life. With industry-leading expertise, we ensure your music videos reach the right audience, amplifying your impact across platforms.
            </p>
            <p className="">
            Trust in our partner for seamless releases, maximizing exposure and success in the competitive music landscape.
            </p>
            <div className="button-container_buttonContainer__YRgZl undefined">
              <Link
                className="button_button__MFmXH button_color__bLscP gradient_border_btn"
                to="/signup"
              >
                Sign Up Now
              </Link>
            </div>
          </div>
          <div className="media_default__Mq0yp media_medium__yJzWA">
            <img
              alt=""
              loading="lazy"
              width={600}
              height={347}
              className="media_image__CtmQY"
              style={{ color: "transparent", borderRadius: "50px" }}
              src="Images/Distribution_Image.png"
            />
          </div>
        </Container>
      </section>
    </div>
  );
};

export default GetDiscovered;
